module.exports = __webpack_public_path__ + "img/solicta_aval_academico.5e750621.jpg";